<template>
  <div>
    <b-form-file
      @input="uploadFile"
      class="mb-4"
      v-model="tepdinhkemfile"
      placeholder="Nhấn vào đây để thêm tệp đính kèm"
      browse-text="..."
      multiple
    ></b-form-file>
    <b-table
      bordered
      head-variant="dark"
      hover
      responsive
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template v-slot:cell(name)="data">
        <a :href="attach_url + data.item.name" target="_blank">{{data.item.name}}</a>
      </template>
      <template v-slot:cell(action)="data">
        <b-link href="#" @click.prevent="deleteItem(data)" class="text-danger">
          <i class="fas fa-trash mr-2"></i> Xóa
        </b-link>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "TaskAttach",
  props: ["item"],
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Tệp đính kèm",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "80px !important" },
        },
      ],
      items: [],
      attach_url: `../attach/task/${this.item.id}/`,
      tepdinhkemfile: null,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.item != null) {
        axios
          .get(`/api/taskattach/${this.item.id}`)
          .then((res) => {
            this.items = res.data;
          })
          .catch((err) => {
            alert(err);
          });
      }
    },
    uploadFile() {
      const formData = new FormData();
      for (var i = 0; i < this.tepdinhkemfile.length; i++) {
        formData.append("tepdinhkemfile", this.tepdinhkemfile[i]);
      }
      formData.append("taskID", this.item.id);
      axios
        .post("/api/taskattach", formData)
        .then((res) => {
          for (var i = 0; i < res.data.length; i++) {
            this.items.push(res.data[i]);
          }
          this.tepdinhkemfile = null;
        })
        .catch((err) => {
          this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
        });
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`/api/taskattach/${data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
